var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && _vm.value.length)?_c('span',[_c('el-link',{on:{"click":_vm.editImage}},[_vm._v(_vm._s(_vm.btnText))]),_c('ProdImageEditorDrawer',{ref:"editImagesRef",on:{"on-save-batch":_vm.handleSaveBatch}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }